import styled from "styled-components";

export const CacheContent = styled.div`
  flex-basis: 40%;
  margin-right: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;
